import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ActionButton from '../../components/ActionButton';

export default function ConfirmModal(props) {
    const { handleClose, message, title, onSubmitConfirm, open } = props;
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" className="font-family">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className="font-family">
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ActionButton variant="settle" onClick={handleClose} autoFocus>
                        Cancel
                    </ActionButton>
                    <ActionButton variant="danger" onClick={onSubmitConfirm}>
                        Confirm
                    </ActionButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}